<template>
 <div class="Home-container"   >
    <TopBar title="内江数循"  :color="color" :src="logo" v-if="_router" />
    <router-view />
    <div id="bottom">
      <div class="bottom-body">
        <div class="body-left">
            <div class="left-head">
               <img :src="logoimg" alt="" class="logoimg">
                
            </div>
            <div class="left-bottom">© 2025  内江高新科技投资服务有限责任公司. 蜀ICP备2024112033号</div>
        </div>
        <div class="middle1">
            <div class="middle1-head">
                <p>联系方式</p>
            </div>
            <div class="middle1-body">
                <div class="body-item">
                    <span class="title">客服邮箱:</span>
                    <span>bd@njsx.cn</span>
                </div>
                <div class="body-item">
                    <span class="title">联系电话:</span>
                    <span>181  8087  0313</span>
                    <span class="title">(7*24小时)</span>
                </div>
            </div>
        </div>
        <div class="middle2">
              <div class="middle1-head">
                <p>外部链接</p>
            </div>
            <div class="middle1-body">
                <div class="body-item">
                    <span class="title go" @click="handleclick">数循数据资源超市</span>
                </div>
              
            </div>
        </div>
        <div class="body-right">
            <div class="QRcode">
                <img src="../../assets1/Qr.png" alt="">
            </div>
            <div class="rt-bottom" >
                关注数循公众号
            </div>
        </div>

      </div>
    </div>
 </div>
</template>

<script>
import logoimg from "@/assets1/高新区logo/logo-白.png";
import logo1 from "@/assets1/logo_slices/编组 2.png"
import logo2 from "@/assets1/logo_slices/编组 2(1).png"
import TopBar from "@/components/TopBar.vue"
import bgimg from '@/assets1/首页_slices (1)/编组 2.png'
export default {
components:{TopBar},
data(){
    return{
        color:'#fff',
        logo:logo1,bgimg,
        logoimg
    }
},
computed:{
    _router(){
        if(this.$route.path!=="/dataMarket"){
            return true
        }
        else{
            return false
        }
    }
},
updated(){
   if(this.$route.path==='/sjfw'){
    this.color="#000"
    this.logo=logo2
   } else{
       this.color="#fff"
    this.logo=logo1
   }  
},
created(){
       if(this.$route.path==='/sjfw'){
    this.color="#000"
    this.logo=logo2
   }   
},
methods:{
    setScorll(){
    //    console.log( this.$store.state.scorllTop);
    
       this.$store.commit('setScorllTop',window.scrollY)

       
        
    },
    handleclick(){
        this.$router.push('/Dataset')
    }
},
mounted(){
    // this.$refs.box.addEventListener('scroll',()=>{
    //     console.log(1);
        
    // })
      window.addEventListener('scroll',this.setScorll)
    
}
}
</script>

<style scoped>
.logoimg{
    height: 45px;
    object-fit: cover;
}
.go{
    cursor: pointer;
}
.body-right{
font-family: Regular;
    /* font-family: Light; */
font-weight: 400;
font-size: 14px;
    text-align: center;
line-height: 20px;
    letter-spacing: 1.1px;
    color: #818489;
}
.title{
font-family: Regular;
font-weight: 400;
font-size: 14px;
color: #838B9A;
line-height: 17px;
margin-right: 5px;
}
.Home-container{
        scroll-behavior: smooth;
        min-width:1920px ;
     

    }
#bottom{
    min-width: 1920px;
    background-color: #2e3137;
    padding: 40px;
display: flex;
justify-content: center;
color: #fff;

}
.bottom-body{
    width: 70%;
    height: 150px;
 
    display: flex;
 
}
.QRcode img{
    width: 110px;
    height: 110px;
   margin-bottom: 14px;
    object-fit: cover;
    
}.body-left{
    flex: 3;
}
.middle1{
    flex: 2;
}
.middle2{
    flex: 1.5;
}
/* .left-head img{width: 335px;height: 45px;} */
.left-head{
    height: 48px;
    display: flex;
    margin-bottom: 85px;
}
.left-head p{
    font-family: Regular;
    font-size: 24px;
    height:48px;
    line-height: 48px;
    font-weight: 500;
    margin-left: 16px;
 }
.icon-github{
    font-size: 48px;
}
.body-left{
    display: flex;
    flex-direction: column;
}
.left-bottom{
    font-size: 13px;
    color: #818489;
    font-family: Medium;
}
.middle1-head{
    font-family: Light;
font-weight: 400;
font-size: 18px;
color: #FFFFFF;
    margin-bottom: 26px;
}
.body-item{
    font-family: Light;
font-weight: 400;
font-size: 14px;
color: #fff;
line-height: 17px;
    letter-spacing: 1px;
    margin-bottom: 12px;
}
.body-item:last-child{
    margin-bottom: 0;
}
</style>